module.exports = __webpack_public_path__ + "img/TRX.68f8f313.svg";